import * as React from "react";
import { Image, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import './SelfInspectSteps.css'
import { hideSelfInspectStepsScreen, showFullscreenCamera } from "../../../actions/fullscreenActions";
import {
    CHILLI_MONTHLY_RIGHT_CHECKMARK
} from "../../../constants/copy";
import { photoData } from "../../../actions/cameraActions";
import { setMileage } from "../../../actions/selfInspectActions";

class SelfInspectSteps extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            totalMileage: "",
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleMileageClick = this.handleMileageClick.bind(this);
        this.handleMileageChange = this.handleMileageChange.bind(this);
        this.bottom1Classname = this.bottom1Classname.bind(this);
    }

    componentDidUpdate() {
        if (this.props.camera.step1RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.step2RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.step3RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.canSubmitMonthlyMileage === false) {
            this.props.dispatchPhotoData({
                canSubmitMonthlyMileage: true,
            });
        }
    }

    async handleClick() {
        this.props.dispatchHideSelfInspectStepsScreen();

        this.props.dispatchShowFullscreenCamera();
    }

    async handleMileageClick() {
        this.props.dispatchSetMileage(this.state.totalMileage)
        this.props.dispatchHideSelfInspectStepsScreen();
    }

    async handleMileageChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    bottom1Classname() {
        switch (this.props.profile.selfInspectionStep) {
            case 'mileage reading': return 'bottom1-mileagereading'
            case 'optionalphotos': return 'bottom1 font-weight-bold'
            default: return "bottom1";
        }
    }

    render() {
        let sectionclass = "";
        let header = "";
        let multilineheader = "no";
        let headerpart1 = "";
        let headerpart2 = "";
        let bottom1 = "";
        let bottom2 = ""
        let bottom3 = ""
        let imageUrl = "";
        let next = <div></div>
        let caseFilter = this.props.profile.selfInspectionStep;

        if (this.props.profile && this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.productName.toLowerCase() === "motorbike") caseFilter = this.props.profile.selfInspectionStep + "-motorbike";
        //if (this.props.profile && this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.productName.toLowerCase() !== "chilli" && this.props.profile.selfInspectionStep === "mileage reading") this.props.profile.selfInspectionStep = "mileage photo";

        switch (caseFilter) {
            /// Note on section class: 
            /// Automatically creates "section-" + caseFilter as a section holder classname, I.e. "section-front".
            /// Or you can manually specify in the case of classnames with spaces like "mileage-photo".
            ///
            /// Note on headerpart1/2:
            /// To better match the design and simulate the break in the string (as per the design), headers are now split into 2 parts.
            /// If single line header, use the header var. If multilineheader, set multlineheader to "yes" and set headerpart1 and headerpart2;
            case "front":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "front of your car";
                bottom1 = "Please make sure your entire car fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/front.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "front-motorbike":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "front of your motorbike";
                bottom1 = "Please make sure your entire motorbike fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/front-motorbike.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "back":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "back side of your car";
                bottom1 = "Please make sure your entire car fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/back.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "back-motorbike":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "back side of your motorbike";
                bottom1 = "Please make sure your entire motorbike fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/back-motorbike.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "left":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the left";
                headerpart2 = "side of your car";
                bottom1 = "Please make sure your entire car fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/left.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "left-motorbike":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the left";
                headerpart2 = "side of your motorbike";
                bottom1 = "Please make sure your entire motorbike fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/left-motorbike.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "right":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "right side of your car";
                bottom1 = "Please make sure your entire car fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/right.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "right-motorbike":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of the";
                headerpart2 = "right side of your motorbike";
                bottom1 = "Please make sure your entire mortorbike fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/right-motorbike.png";
                next = <>   
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "dashboard":
                sectionclass = caseFilter;
                header = "Dashboard photo";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Take a photo of your car’s dashboard";
                bottom2 = "80 % of the dash needs to fit into the guidelines";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/dashboard.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "mileage photo":
                sectionclass = "mileage-photo";
                header = "";
                multilineheader = "yes";
                headerpart1 = "Photo of";
                headerpart2 = "car’s mileage";
                bottom1 = "Take a photo of your car’s mileage meter (this is the meter that shows how many kms your car has ever driven)";
                bottom2 = "The whole mileage reading needs to fit into the guidelines";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/mileagephoto.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "mileage photo-motorbike":
                sectionclass = "mileage-photo-motorbike";
                header = "Photo of your motorbike’s mileage";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Take a photo of your motorbike’s mileage meter (this is the meter that shows how many kms your motorbike has ever driven)";
                bottom2 = "The whole mileage reading needs to fit into the guidelines";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/mileagephoto.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "odometer":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Photo of";
                headerpart2 = "car’s mileage";
                bottom1 = "Take a photo of your car’s mileage meter (this is the meter that shows how many kms your car has ever driven)";
                bottom2 = "The whole mileage reading needs to fit into the guidelines";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/mileagephoto.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "mileage reading":
                sectionclass = "mileage-reading";
                header = "Mileage reading";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Enter your mileage reading";
                bottom2 = "Hint: This shows all the kms your car has ever driven";
                bottom3 = "Enter total mileage";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/mileagereading.png";
                next = <>
                    <div>
                        <input type="number" className="totalMileage w-100" id="totalMileage" name="totalMileage" value={this.state.totalMileage} onChange={this.handleMileageChange} />
                    </div>
                    <Button className="btn btn-solid-green btn-got-it btn-got-it-mileagereading" onClick={this.handleMileageClick} disabled={this.state.totalMileage === ""}>Done</Button>
                </>
                break;

            case "mileage reading-motorbike":
                sectionclass = "mileage-reading-motorbike";
                header = "Mileage reading";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Enter your mileage reading";
                bottom2 = "Hint: This shows all the kms your motorbike has ever driven";
                bottom3 = "Enter total mileage";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/mileagereading.png";
                next = <>
                    <div className="pb-4">
                        <input type="number" className="totalMileage w-100" id="totalMileage" name="totalMileage" value={this.state.totalMileage} onChange={this.handleMileageChange} />
                    </div>
                    <Button className="btn btn-solid-green btn-got-it-mileagereading" onClick={this.handleMileageClick} disabled={this.state.totalMileage === ""}>Done</Button>
                </>
                break;

            case "tow, roll & bull bar":
                sectionclass = "tow-roll-bull-bar";
                header = "Snap a photo of your car’s tow, roll & bull bar";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Please make sure your car’s tow, roll & bull bar fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/bullbar.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "tow, roll & bull bars":
                sectionclass = "tow-roll-bull-bars";
                header = "Snap a photo of your car’s tow, roll & bull bar";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Please make sure your car’s tow, roll & bull bar fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/bullbar.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "tow bars":
                sectionclass = "tow-bars";
                header = "Snap a photo of your car’s tow bar";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Please make sure your car’s tow bar fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/bullbar.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "tow bar":
                sectionclass = "tow-bar";
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of your";
                headerpart2 = "car’s tow bar";
                bottom1 = "Please make sure your car’s tow bar fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/bullbar.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "leather seats":
                sectionclass = "leather-seats";
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of your";
                headerpart2 = "car’s leather seats";
                bottom1 = "Please make sure your car’s leather seats fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/leatherseats.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "sunroof":
                sectionclass = caseFilter;
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of your";
                headerpart2 = "car’s sunroof";
                bottom1 = "Please make sure your car’s sunroof fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/sunroof.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "car rims":
                sectionclass = "car-rims";
                header = "";
                multilineheader = "yes";
                headerpart1 = "Snap a photo of your";
                headerpart2 = "car rims";
                bottom1 = "Please make sure your car rims fits into the photo";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/carrims.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;

            case "optionalphotos":
                sectionclass = "optionalphotos";
                header = "Optional photos";
                multilineheader = "no";
                headerpart1 = "";
                headerpart2 = "";
                bottom1 = "Any extra photos you’d like to add";
                bottom2 = "Please make sure that any photos you add here, fit into the frame";
                imageUrl = "./Images/SelfInspect/SelfInspectSteps/optional.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;
        }

        return (

            <>
                <div id="SelfInspectSteps" className={(this.props.profile.selfInspectionStep === "dashboard" || this.props.profile.selfInspectionStep === "mileage photo" || this.props.profile.selfInspectionStep === "mileage reading") ? 'top-header LoadingDiv text-center selfinspect-red-modal-container' : 'header LoadingDiv text-center selfinspect-red-modal-container'}>
                    <div className={"selfinspect-red-modal-container-inner" + " section-" + sectionclass}>
                        <div className="row">
                            {(this.props.profile.selfInspectionStep === "dashboard" || this.props.profile.selfInspectionStep === "mileage reading" || this.props.profile.selfInspectionStep === "mileager reading" || this.props.profile.selfInspectionStep === "mileage photo" ) &&
                                <div className="col-12">
                                    <h2 className="header topheader-marginbottom-adjust">
                                        {
                                            (multilineheader === "no") &&
                                            <>
                                                {header}
                                            </>
                                        }
                                        {
                                            (multilineheader === "yes") &&
                                            <>
                                                {headerpart1}
                                                <br className="nomultilinebreak" />
                                                {headerpart2}
                                            </>
                                        }
                                    </h2>
                                </div>
                            }
                            <div className="col-12 selfinspect-red-modal-image-col">
                                <div className="selfinspect-red-modal-image-box">
                                    <Image src={imageUrl} alt="loading" className="img-fluid gif" />
                                </div>
                            </div>
                            <br />
                            {!(this.props.profile.selfInspectionStep === "dashboard" || this.props.profile.selfInspectionStep === "mileage photo" || this.props.profile.selfInspectionStep === "mileage reading") &&
                                <div className="col-12">
                                <h2 className="header">
                                    {
                                        (multilineheader === "no") &&
                                        <>
                                            {header}
                                        </>
                                    }
                                    {
                                        (multilineheader === "yes") &&
                                        <>
                                            {headerpart1}
                                            <br className="nomultilinebreak" />
                                            {headerpart2}
                                        </>
                                    }
                                    </h2>
                                </div>
                            }
                            <div className="col-12 bottom-steps text-center ">
                                <div className="col-12">
                                    <p className={this.props.profile.selfInspectionStep === "mileage reading" ? "bottom1-mileagereading" : "bottom1"}>{bottom1}</p>
                                    <p className="bottom2">{bottom2}</p>
                                    <p className="bottom3">{bottom3}</p>
                                    {next}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        modal: state.modal,
        profile: state.profile,
        auth: state.auth,
        camera: state.camera,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        dispatchHideSelfInspectStepsScreen: () => dispatch(hideSelfInspectStepsScreen()),
        dispatchShowFullscreenCamera: () => dispatch(showFullscreenCamera()),
        dispatchSetMileage: (mileage) => dispatch(setMileage(mileage)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelfInspectSteps)